import { Box, Button, Card, Grid, useMediaQuery } from '@mui/material'
import React from 'react'
import { Linker } from 'src/Components/Ui/Linker'
import { useLocale } from 'src/locales/useLocale'

const baseUrl = '/hard/atoms/japan/'
const AtomsJapanSeries: React.FC = () => {
  const { t, isJa } = useLocale()
  const isMobile = useMediaQuery('(max-width:430px)')
  return (
    <Box>
      <Box p={2} data-testid={'position-selection-page'}>{`${t.HARD} / ATOMS / ${t.POSITION_SELECTION_PAGE}`}</Box>
      <Box py={2}>
        <Card style={{ padding: '16px' }}>
          <Box>{t.GLOVE}</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}pitcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      {t.PITCHER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}infielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      {t.INFIELDER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}outfielder`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      {t.OUTFIELDER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              {isJa && (
                <Grid item width={isMobile ? '100%' : 'unset'}>
                  <Box p={1} my={1}>
                    <Linker href={`${baseUrl}youth/glove`}>
                      <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                        YOUTHグラブ
                      </Button>
                    </Linker>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Card>
        <Box m={2} />
        <Card style={{ padding: '16px' }}>
          <Box p={0}>{t.MITT}</Box>
          <Box display={'flex'} justifyContent={'space-around'}>
            <Grid container>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}catcher`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      {t.CATCHER}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              <Grid item width={isMobile ? '100%' : 'unset'}>
                <Box p={1} my={1}>
                  <Linker href={`${baseUrl}first`}>
                    <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                      {t.FIRST_BASEMAN}
                    </Button>
                  </Linker>
                </Box>
              </Grid>
              {isJa && (
                <Grid item width={isMobile ? '100%' : 'unset'}>
                  <Box p={1} my={1}>
                    <Linker href={`${baseUrl}youth/mitt`}>
                      <Button variant={'contained'} color={'primary'} size={'large'} fullWidth={isMobile}>
                        YOUTHミット
                      </Button>
                    </Linker>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Card>
      </Box>
    </Box>
  )
}

export default AtomsJapanSeries
